import { getCognitoLog } from 'components/DataProvider/functions'
import {
  eachWeekendOfMonth,
  endOfYear,
  format,
  getDay,
  isAfter,
  parseISO,
  subDays
} from 'date-fns/fp'
import { find, isNil, reverse } from 'lodash/fp'
import { useTranslate } from 'react-admin'
import log from 'loglevel'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid
} from '@mui/material'
import { DateInput, useNotify } from 'components/Util'

export const CognitoLog: React.FC<{
  partner: string
  open: boolean
  setOpen: (open: boolean) => void
}> = ({ partner, open, setOpen }) => {
  const translate = useTranslate()
  const { getValues } = useFormContext()
  const notify = useNotify()
  const handleCognitoLog = (dateArg?: string): void => {
    notify('downloading', { autoHideDuration: null })
    const enhanced = !isNil(dateArg)
    const date = enhanced ? dateArg : format('yyyy-MM-dd')(Date.now())
    getCognitoLog(partner, date, enhanced)
      .then(({ data }) => {
        if (!isNil(data)) {
          const binaryString = window.atob(data)
          const len = binaryString.length
          const bytes = new Uint8Array(len)
          for (let i = 0; i < len; ++i) {
            bytes[i] = binaryString.charCodeAt(i)
          }
          const blob = new Blob([bytes], {
            type: !enhanced
              ? 'application/zip'
              : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = URL.createObjectURL(blob)
          const download = document.createElement('a')
          download.href = url
          download.download = `${format('yyyyMM')(
            parseISO(date)
          )}ログインログ_${format('yyyyMMdd')(Date.now())}.${
            !enhanced ? 'zip' : 'xlsx'
          }`
          download.click()
          window.URL.revokeObjectURL(url)
        }
      })
      .catch(log.error)
      .finally(() => {
        notify('downloading', { autoHideDuration: 0 })
      })
  }
  const handleClose = (): void => {
    setOpen(false)
  }
  const onClick = (): void => {
    const { date: dateValue } = getValues()
    const date = find(
      (item: Date) => !isAfter(Date.now())(item) && getDay(item) === 0
    )(reverse(eachWeekendOfMonth(parseISO(dateValue))))
    if (!isNil(date)) {
      handleCognitoLog(format('yyyy-MM-dd')(date))
    }
    setOpen(false)
  }
  return (
    <Dialog onClose={handleClose} open={open} maxWidth="md" fullWidth>
      <DialogTitle>
        {translate(`resources.dashboard.dialogs.selectMonth.title`)}
      </DialogTitle>
      <DialogContent>
        <Grid container sx={{ justifyContent: 'center' }}>
          <Grid size={6}>
            <DateInput
              label=""
              source="date"
              disableFuture
              minDate={parseISO('2025-01-01')}
              maxDate={endOfYear(Date.now())}
              views={['year', 'month']}
              defaultValue={format('yyyy-MM-dd')(
                subDays(getDay(Date.now()))(Date.now())
              )}
              withControl
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        sx={{ justifyContent: 'flex-start', ml: '1em', mt: '-1em' }}>
        <Button variant="contained" onClick={onClick}>
          {translate(`resources.dashboard.dialogs.selectDate.buttons.exec`)}
        </Button>
        <Button variant="outlined" onClick={handleClose}>
          {translate(`resources.dashboard.dialogs.selectDate.buttons.cancel`)}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
